// eve-page-context-store — Pro Page setzen die Seiten beim Mount einen
// Context-Block, der dann in EVEs System-Prompt landet. So weiß EVE WO sie
// gerade ist und WAS der User dort sieht.
//
// Verwendung in einer Page:
//   useEffect(() => {
//     setPageContext({
//       pageKey: '/markt/polymarket',
//       title: 'Polymarket',
//       summary: 'Top 30 Märkte nach 24h-Volumen',
//       data: { markets: [...] },
//     });
//     return () => clearPageContext();
//   }, [...]);
//
// Drawer / useRunEve lesen den Context und injizieren ihn in den Prompt.

import { create } from 'zustand';

export interface PageContext {
  /** location.pathname — eindeutiger Page-Key für Chat-History-Lookup. */
  pageKey: string;
  /** Lesbarer Page-Name, kommt im Prompt vor. */
  title: string;
  /** Kurzbeschreibung was diese Page tut/zeigt. */
  summary?: string;
  /** Strukturierte Daten die EVE sehen können soll. JSON-stringified im Prompt. */
  data?: Record<string, unknown>;
  /** Optional vorformatierter Text-Block — überschreibt automatische
   *  Serialisierung von `data`. */
  formattedBlock?: string;
}

interface PageContextState {
  current: PageContext | null;
  setPageContext: (ctx: PageContext) => void;
  clearPageContext: () => void;
}

export const useEvePageContextStore = create<PageContextState>((set) => ({
  current: null,
  setPageContext: (ctx) => set({ current: ctx }),
  clearPageContext: () => set({ current: null }),
}));

export const selectCurrentPageContext = (s: PageContextState): PageContext | null =>
  s.current;

/**
 * Formatiert einen PageContext zu einem Prompt-Block der in den System-Prompt
 * vor dem AGENT_TASK eingefügt wird.
 */
export function formatPageContextBlock(ctx: PageContext | null): string {
  if (!ctx) return '';
  if (ctx.formattedBlock) {
    return `\n\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
PAGE_CONTEXT — wo der User gerade ist:
Page: ${ctx.title} (${ctx.pageKey})
${ctx.summary ? `Was Doc sieht: ${ctx.summary}\n` : ''}
${ctx.formattedBlock}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`;
  }
  const dataStr = ctx.data ? JSON.stringify(ctx.data, null, 2) : '';
  return `\n\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
PAGE_CONTEXT — wo der User gerade ist:
Page: ${ctx.title} (${ctx.pageKey})
${ctx.summary ? `Was Doc sieht: ${ctx.summary}\n` : ''}${dataStr ? `\nDaten der Page:\n${dataStr}\n` : ''}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`;
}
